module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bookitalic-webfont.bb13e363.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bookitalic-webfont.eot
// module id = 98
// module chunks = 3